<template>
  <div class="category-navigation" :class="{ active: isActive }">
    <router-link :to="to"
      ><div>{{ title }}</div></router-link
    >
  </div>
</template>

<script>
export default {
  name: 'CategoryNavigation',
  props: {
    title: String,
    to: Object,
    active: { type: Boolean, default: false },
  },
  data() {
    return {
      isActive: this.active,
    };
  },
};
</script>

<style scoped>
.category-navigation {
  display: inline-block !important;
}

.category-navigation .router-link-exact-active div {
  color: #ffffff;
  border-radius: 100px;
  background: #8e2de2; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #4a00e0,
    #8e2de2
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #4a00e0,
    #8e2de2
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}

.category-navigation a {
  color: #212121;
  text-decoration: none;
  font-weight: bolder;
  font-size: 0.8rem;
}
.category-navigation div {
  padding: 8px 16px;
}
</style>
